<template>
    <tr>
        <td>#{{ invoice.id }}</td>
        <td>{{ invoice.issued_date }}</td>
        <td>{{ invoice.car.model_type_en }}</td>
        <td>{{ getCurrency }}{{ getDueAmount() | formatNumber }}</td>
        <td>{{ getCurrency }}{{ invoice.paid_amount | formatNumber }}</td>
        <td>
            <div class="select is-fullwidth">
                <select v-model="deposit" v-on:change="depositPayment()">
                    <option selected :value="null" disabled>Deposit</option>
                    <option value="100%">Pay in full</option>
                    <option value="50%-50%">50%</option>
                    <option value="30%-70%">30%</option>
                </select>
            </div>
        </td>
    </tr>
</template>

<script>

    export default {
        props: ['invoice', 'transactionTotals'],
        components: {

        },
        data() {
            return {
                //deposit: this.invoice.deposit_payment
            }
        },
        methods: {
            getDueAmount(){
                if(this.invoice.currency == 2 && this.transactionTotals.currency != 2){
                    return Math.round(this.invoice.balance_due * this.invoice.rate) - this.invoice.paid_amount;
                }else{
                    return this.invoice.balance_due - this.invoice.paid_amount;
                }
            },
            depositPayment(){
                if(this.deposit == '100%'){
                    if(this.invoice.currency == 1 || this.invoice.currency == null){
                        this.invoice.paid_amount = this.invoice.sub_total
                    }else{
                        this.invoice.paid_amount = Math.round(this.invoice.sub_total * this.invoice.rate)
                    }
                }else if(this.deposit == '50%-50%'){
                    if(this.invoice.currency == 1 || this.invoice.currency == null){
                        this.invoice.paid_amount = this.invoice.sub_total * 50/100
                    }else{
                        this.invoice.paid_amount = Math.round((this.invoice.sub_total * 50/100) * this.invoice.rate)
                    }
                }else if(this.deposit == '30%-70%'){
                    if(this.invoice.currency == 1 || this.invoice.currency == null){
                        this.invoice.paid_amount = this.invoice.sub_total * 30/100
                    }else{
                        this.invoice.paid_amount = Math.round((this.invoice.sub_total * 30/100) * this.invoice.rate)
                    }
                }
                this.$store.dispatch('paymentDepositInvoice', {transaction_id: this.$route.params.id, invoice_id: this.invoice.id, deposit: this.deposit, paid_amount: this.invoice.paid_amount})
            }
        },
        computed: {
            deposit: {
                get(){
                    return this.invoice.deposit_payment;
                },
                set(value){
                    this.invoice.deposit_payment = value;
                }
            },
            getCurrency: function () {
                return this.transactionTotals.currency == 2 ? '$' : '¥'
            }
        }
    }
</script>

<style scoped>
    td {
        font-size: 12px;
    }
    .picture-td {
        width: 65px;
    }
    .link {
        cursor: pointer;
    }
    .image {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/Balance-Statement/UnpaidClientInvoiceTableRow.vue